export default {
  namespaced: true,
  state: {
    typeCode: '', //  typeCode: 'area', // 广告位:advertising 场地:area
    isUpdateAduitList: false, // 是否更新审核列表
    isUpdateMyAppointmentList: false, // 是否更新我的预约列表
    adsItem: '',
    orderItem: '',
  },
  getters: {
    typeCode: state => state.typeCode || 'advertising',
    isAds: state => state.typeCode === 'advertising', // 是否是广告位
    isUpdateAduitList: state => state.isUpdateAduitList,
    isUpdateMyAppointmentList: state => state.isUpdateMyAppointmentList,
    adsItem: state => state.adsItem,
    orderItem: state => state.orderItem,
  },
  mutations: {
    setTypeCode(state, data) {
      state.typeCode = data;
    },
    setAdsItem(state, data) {
      state.adsItem = data;
    },
    setOrderItem(state, data) {
      state.orderItem = data;
    },
    // 更新审核列表
    updateAduitList(state, data) {
      state.isUpdateAduitList = data;
    },
    // 更新预约列表
    updateMyAppointmentList(state, data) {
      state.isUpdateMyAppointmentList = data;
    },
  },
  actions: {},
};
